export default __webpack_public_path__ + "static/media/timer_m3.5bb44400.png";